import React, { useCallback, useEffect, useRef, useState } from "react";

import { CircularIndeterminate, FormButton } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
    userCoords,
} from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { MIAConnectionIns, paisGet, tipoDeDocumentoGet, usuarioBasicosGet } from "services/services-mia";

const sexos = [
    { sexoCod: "M", sexoNombre: "Masculino" },
    { sexoCod: "F", sexoNombre: "Femenino" },
    { sexoCod: "X", sexoNombre: "No Binario" }
];

const forceOptions = [
    { optCod: "N", optNombre: "Si" },
    { optCod: "Y", optNombre: "No" },
]

const emailRegex = /^(([^<>()[\]\\.,;:#\s@"]+(\.[^<>()[\]\\.,;:#\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default function InsertModal({ updateList, roles, servicio, closeModal }) {
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [paises, setPaises] = useState([]);
    const [tiposDeDocumento, setTiposDeDocumento] = useState([]);
    const [userExisted, setUserExisted] = useState(false)

    const [placeholderDNI, setPlaceholderDNI] = useState('')
    const [regexDNI, setRegexDNI] = useState(/./)

    const formikRef = useRef();

    const functions = {
        setSnackbarInfo,
        setInRequest,
        setIsOpen: closeModal,
        updateList,
    };

    const [step, setStep] = useState({
        basico: true,
        contacto: false,
        conexionForzada: true
    });

    const coords = useRecoilValue(userCoords);

    const getPais = useCallback(async () => {
        const { result: paises, status } = await paisGet(credentials);
        if (status.code !== 1) {
            return;
        }
        setPaises(paises);
        let paisIdSelected = paises[0].paisId;
        if (coords) {
            const { lat: userLat, lng: userLng } = coords;
            let Latitud = paises[0].paisLatitudCentro - userLat;
            let Longitud = paises[0].paisLongitudCentro - userLng;
            for (let i = 1; i < paises.length; i++) {
                const { paisLatitudCentro: lat, paisLongitudCentro: lng } = paises[i];
                if (Math.abs(lat - userLat + lng - userLng) < Math.abs(Latitud + Longitud)) {
                    paisIdSelected = paises[i].paisId;
                    Latitud = lat - userLat;
                    Longitud = lng - userLng;
                }
            }
        }
        selectPais(paisIdSelected);
        return paisIdSelected;
    }, [credentials, coords]);

    const getTiposDeDocumento = useCallback(async (paisId) => {
        if (!paisId) return;
        const { result, status } = await tipoDeDocumentoGet(
            paisId,
            credentials
        );
        if (status.code !== 1) {
            return;
        }
        setTiposDeDocumento(result);
        selectTipoDeDocumento(result[0]);
    }, [credentials]);

    useEffect(() => {
        if (Object.keys(credentials).length === 0) return;
        (async () => {
            setIsLoading(true);
            console.debug('Entra 1')
            const paisId = await getPais();
            console.debug('Entra 2')
            await getTiposDeDocumento(paisId);
            console.debug('Entra 3')
            setIsLoading(false);
        })()
    }, [credentials, getPais, getTiposDeDocumento]);

    const selectPais = (paisId) => {
        formikRef.current.setFieldValue("pais", paisId)
    }

    const selectTipoDeDocumento = (tipoDeDocumento) => {
        formikRef.current.setFieldValue("tipoDeDocumento", tipoDeDocumento.tipoDeDocumentoCod);
        setPlaceholderDNI(tipoDeDocumento.tipoDeDocumentoPlaceholder)
        setRegexDNI(tipoDeDocumento.tipoDeDocumentoRegExp ? tipoDeDocumento.tipoDeDocumentoRegExp : "")
    }

    const handleChangePais = async (event) => {
        setIsLoading(true);
        const paisId = event.target.value;
        selectPais(paisId)
        await getTiposDeDocumento(paisId);
        setIsLoading(false);
    }

    const handleChangeTipoDeDocumento = (event) => {
        const tipoDeDocumentoCod = event.target.value;
        const tipoDeDocumento = tiposDeDocumento.find(td => td.tipoDeDocumentoCod === tipoDeDocumentoCod)
        selectTipoDeDocumento(tipoDeDocumento);
    }

    const handleConnection = async (values, resetForm) => {
        setInRequest(true);
        const formattedDNI = values.dni.replace(/\D/g, "").slice(-8);
        const tipoDeDocumentoId = tiposDeDocumento.find(td => td.tipoDeDocumentoCod === values.tipoDeDocumento).tipoDeDocumentoId;
        const response = await usuarioBasicosGet({
            tipoDeDocumentoId: tipoDeDocumentoId,
            usuarioNroDeDocumento: formattedDNI,
            usuarioSexo: values.sexo,
            usuarioFechaDeNacimiento: values.fechaNacimiento,
        }, credentials);
        if (response.result.length === 0) {
            setUserExisted(false)
        }
        if (response.result.length === 1) {
            formikRef.current.setFieldValue("nombre", response?.result[0]?.usuarioNombres)
            formikRef.current.setFieldValue("apellido", response?.result[0]?.usuarioApellidos)
            response?.result[0]?.usuarioMail ? formikRef.current.setFieldValue("email", response?.result[0]?.usuarioMail) : formikRef.current.setFieldValue("email", "")
            setUserExisted(true)
        }
        if (response.result.length > 1) {
            setSnackbarInfo({
                message: "Hay más de un usuario con esos datos. Verifique documento, sexo y fecha de nacimiento o contacte soporte.",
                severity: "warning",
                open: true,
            });
        }
        setStep({
            basico: false,
            contacto: true,
            conexionForzada: true
        })

        setInRequest(false);
    };

    const handleConnectionContact = async (values, resetForm) => {
        setInRequest(true);
        const payload = {
            merchantId: credentials.merchantId,
            servicioCod: servicio.servicioCod,
            rolCod: values.rol,
            tipoDeDocumentoCod: values.tipoDeDocumento,
            usuarioNroDeDocumentoX: values.dni,
            usuarioSexo: values.sexo,
            usuarioFechaDeNacimiento: values.fechaNacimiento,
            usuarioMail: values.email,
            usuarioApellidos: values.apellido,
            usuarioNombres: values.nombre,
            merchantServicioUsuarioTiporel: "S",
            merchantServicioUsuarioForzado: values.conexionForzada,
        };
        const response = await MIAConnectionIns(payload, credentials);

        handleResponse(
            response,
            "Conexión creada exitosamente",
            functions
        );

        setInRequest(false);
        setStep({
            basico: true,
            contacto: false,
            conexionForzada: true
        })
        resetForm();
        closeModal()
    };

    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                dni: "",
                email: "",
                sexo: "M",
                rol: roles ? roles[0].rolCod : "",
                apellido: "",
                nombre: "",
                fechaNacimiento: "",
                tipoDeDocumento: "",
                pais: "",
                conexionForzada: "N"
            }}
            validationSchema={
                yup.object({
                    dni: yup.string(FORM_ERROR_MESSAGES.text)
                        .required(FORM_ERROR_MESSAGES.required)
                        .matches(regexDNI, { message: "Número de documento inválido" }),
                    apellido: step.contacto
                        ? yup.string(FORM_ERROR_MESSAGES.text)
                            .required(FORM_ERROR_MESSAGES.required)
                        : yup.string(FORM_ERROR_MESSAGES.text)
                            .nullable(),
                    nombre: step.contacto
                        ? yup.string(FORM_ERROR_MESSAGES.text)
                            .required(FORM_ERROR_MESSAGES.required)
                        : yup.string(FORM_ERROR_MESSAGES.text)
                            .nullable(),
                    email: step.contacto
                        ? yup.string(FORM_ERROR_MESSAGES.text)
                            .required(FORM_ERROR_MESSAGES.required)
                            .matches(emailRegex, { message: "Email inválido" })
                        : yup.string(FORM_ERROR_MESSAGES.text)
                            .nullable(),
                    rol: step.contacto
                        ? yup.string(FORM_ERROR_MESSAGES.text)
                            .required(FORM_ERROR_MESSAGES.required)
                            .oneOf(roles.map((rol) => rol.rolCod))
                        : yup.string(FORM_ERROR_MESSAGES.text)
                            .nullable(),
                    sexo: step.basico
                        ? yup.string(FORM_ERROR_MESSAGES.text)
                            .required(FORM_ERROR_MESSAGES.required)
                            .oneOf(sexos.map((s) => s.sexoCod))
                        : yup.string(FORM_ERROR_MESSAGES.text).nullable(),
                    fechaNacimiento: step.basico
                        ? yup.string(FORM_ERROR_MESSAGES.text)
                            .required(FORM_ERROR_MESSAGES.required)
                        : yup.string(FORM_ERROR_MESSAGES.text).nullable(),
                })
            }
            onSubmit={async (values, { setSubmitting, resetForm }) => {
                try {
                    if (step.basico) {
                        await handleConnection(values, resetForm);
                    }
                    else if (step.contacto) {
                        await handleConnectionContact(values, resetForm);
                    }
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-xs"]}>
                    {step.basico && <>
                        <FormikSelectInput
                            fullWidth={true}
                            name="pais"
                            labelText="País"
                            onChange={handleChangePais}
                        >
                            {paises.map(({ paisId, paisNombre }) => (
                                <option
                                    key={paisId}
                                    data-id={paisId}
                                    value={paisId}
                                >
                                    {paisNombre}
                                </option>
                            ))}
                        </FormikSelectInput>
                        <FormikSelectInput
                            fullWidth={true}
                            name="tipoDeDocumento"
                            labelText="Tipo de documento"
                            onChange={handleChangeTipoDeDocumento}
                        >
                            {tiposDeDocumento.map(({ tipoDeDocumentoCod, tipoDeDocumentoNombre }) => (
                                <option
                                    key={tipoDeDocumentoCod}
                                    data-id={tipoDeDocumentoCod}
                                    value={tipoDeDocumentoCod}
                                >
                                    {tipoDeDocumentoNombre}
                                </option>
                            ))}
                        </FormikSelectInput>
                        <FormikTextInput
                            fullWidth={true}
                            name="dni"
                            placeholder={placeholderDNI}
                            labelText="Número de Documento"
                        />
                        <FormikSelectInput
                            fullWidth={true}
                            name="sexo"
                            labelText="Género"
                        >
                            {sexos.map(({ sexoCod, sexoNombre }) => (
                                <option
                                    key={sexoCod}
                                    data-id={sexoCod}
                                    value={sexoCod}
                                >
                                    {sexoNombre}
                                </option>
                            ))}
                        </FormikSelectInput>
                        <FormikTextInput
                            fullWidth={true}
                            name="fechaNacimiento"
                            labelText="Fecha de nacimiento"
                            type="date"
                        />
                    </>}

                    {step.contacto && <>
                        <FormikTextInput
                            fullWidth={true}
                            name="apellido"
                            labelText="Apellido"
                            placeholder="Pérez"
                            disabled={userExisted}
                        />
                        <FormikTextInput
                            fullWidth={true}
                            name="nombre"
                            labelText="Nombre"
                            placeholder="Juan"
                            disabled={userExisted}
                        />
                        <FormikTextInput
                            fullWidth={true}
                            name="email"
                            labelText="Mail"
                            placeholder="ejemplo@gmail.com"
                        />
                        <FormikSelectInput
                            fullWidth={true}
                            name="rol"
                            labelText="Rol"
                        >
                            {roles.map(({ rolCod, rolNombre }) => (
                                <option
                                    key={rolCod}
                                    data-id={rolCod}
                                    value={rolCod}
                                >
                                    {rolNombre}
                                </option>
                            ))}
                        </FormikSelectInput>
                        {step.conexionForzada && <>
                            <FormikSelectInput
                                fullWidth={true}
                                name="conexionForzada"
                                labelText="¿Requiere confirmación por parte del usuario?"
                            >
                                {forceOptions.map(({ optCod, optNombre }) => (
                                    <option
                                        key={optCod}
                                        data-id={optCod}
                                        value={optCod}
                                    >
                                        {optNombre}
                                    </option>
                                ))}
                            </FormikSelectInput>
                        </>}
                    </>}

                    <FormButton
                        inRequest={inRequest || isLoading}
                        newFormData={{ button: step.basico ? "Continuar" : "Crear" }}
                        onCloseModal={closeModal}
                    />

                    {(inRequest || isLoading) && <CircularIndeterminate />}
                </div>
            </Form>
        </Formik>
    );
}
